<template>
  <div class="auth-main">
    <el-form
      ref="loginForm"
      :model="loginData"
      :rules="rules"
      v-if="isHidden"
      class="login-wrapper"
    >
      <div class="login-img-wrapper">
        <img
          :src="this.mxDomain.siderLogo"
          :class="
            this.$config.domain.ename == 'opryifuxin' ||
            this.$config.domain.ename == 'opryifuxing'
              ? ' login-img-big login-img'
              : 'login-img'
          "
          alt=""
          v-show="this.mxDomain.title !== '管理中台'"
        />
      </div>

      <div class="loginTitle">运营中台</div>

      <el-form-item class="input-item" prop="account">
        <el-input
          class="login-input"
          size="medium"
          v-model="loginData.account"
          placeholder="手机号"
          prefix-icon="iconfont el-icon-user"
        ></el-input>
      </el-form-item>
      <el-form-item class="input-item" prop="password">
        <el-input
          class="login-input"
          size="medium"
          type="password"
          v-model="loginData.password"
          placeholder="密码"
          prefix-icon="iconfont icon-lock"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="input-item"
        style="margin-bottom: 5px !important; margin-top: -5px"
      >
        <CaptchaVerify ref="CaptchaVerify" @verify="verifySuccess"></CaptchaVerify>
      </el-form-item>
      <el-form-item>
        <CommonButton
          :buttonTitle="pwdTiltle"
          :isDisable="pwdIsDisable"
          class="login-button"
          :type="'primary'"
          @buttonClick="handlerLogin"
        />
      </el-form-item>
      <el-button type="text" class="login-way" @click="loginAccount"
        >短信验证码登录</el-button
      >
    </el-form>

    <el-form
      ref="loginFormTel"
      :model="telLoginData"
      :rules="rulesTel"
      v-else
      class="login-wrapper"
    >
      <div class="login-img-wrapper">
        <div>
          <img
            :class="
              this.$config.domain.ename == 'opryifuxin' ||
              this.$config.domain.ename == 'opryifuxing'
                ? 'login-img login-img-big'
                : 'login-img'
            "
            :src="this.mxDomain.siderLogo"
            alt=""
            v-show="this.mxDomain.title !== '管理中台'"
          />
        </div>
      </div>
      <div class="loginTitle">运营中台</div>
      <el-form-item class="input-item" prop="telephone">
        <el-input
          placeholder="请输入手机号"
          size="medium"
          type="text"
          class="login-input"
          v-model="telLoginData.telephone"
        >
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item class="input-item" prop="registerCode">
        <el-input
          placeholder="短信验证码"
          size="medium"
          type="text"
          class="login-input"
          v-model="telLoginData.registerCode"
        >
          <template slot="append">
            <div>
              <el-button
                class="get-register"
                :disabled="
                  !telLoginData.telephone || phoneCode !== '获取手机验证码'
                "
                @click="getVerifiCode"
                >{{ phoneCode }}</el-button
              >
            </div>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        class="input-item"
        style="margin-bottom: 5px !important; margin-top: -5px"
      >
        <CaptchaVerify ref="CaptchaVerify" @verify="verifySuccess"></CaptchaVerify>
      </el-form-item>
      <el-form-item>
        <CommonButton
          :buttonTitle="pwdTiltle"
          :isDisable="telLogin"
          class="login-button"
          :type="'primary'"
          @buttonClick="handlerLogin"
        />
      </el-form-item>
      <el-button type="text" class="login-way" @click="loginTel"
        >用户名密码登录</el-button
      >
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CommonButton from "@/components/CommonButton";
import CaptchaVerify from "../../components/CaptchaVerify";
export default {
  components: {
    CommonButton,
    CaptchaVerify,
  },
  data() {
    return {
      verify: {},
      phoneCode: "获取手机验证码",
      timer: null,
      //  默认是 密码登录，当点击获取验证码，滑动验证通过后，修改为 短信登录， 点击登录按钮时判断 loginType,发送不同的数据请求
      loginType: "password", // password, sms
      slideScene: "nc_message", //  滑动验证的 scene
      smartScene: "ic_login", //  智能验证的 scene

      refreshJwt: 0,
      title: "",
      pwdIsDisable: false,
      telIsDisable: false,
      telLogin: false,
      pwdTiltle: "登录",
      wait: 0,
      activeName: "login1",
      isVisible: false,
      isHidden: true,
      codeText: "获取验证码",
      loginData: {
        account: "",
        password: "",
        authenticate: "",
        token: "",
      },
      //手机登录数据
      telLoginData: {
        telephone: "",
        registerCode: "",
      },
      //手机号登录表单验证
      rulesTel: {
        telephone: [
          { required: true, message: "输入手机号", trigger: "blur" },
          { max: 11, message: "请输入11位手机号" },
        ],
        registerCode: [
          { required: true, message: "输入短信验证码", trigger: "blur" },
        ],
      },
      // 表单验证
      rules: {
        account: [{ required: true, message: "输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapMutations({
      setUserIsLogin: "user/setUserIsLogin",
    }),
    ...mapMutations(["handleUserInfo"]),
    smsCountDown() {
      let count = 60;
      this.timer = setInterval(() => {
        if (count > 0 && count <= 60) {
          count--;
          this.phoneCode = `${count}秒重新发送`;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.phoneCode = "获取手机验证码";
        }
      }, 1000);
    },
    async slideVerify(value) {
      if (value) {
        this.telLoginData.sessionId = this.verify.captchaVerifyParam;
        try {
          let result = await this.$api.getLoginCode({
            mobile: this.telLoginData.telephone,
            captchaVerifyParam: this.verify.captchaVerifyParam,
          });
          if (result) {
            this.$message.success("验证码发送成功");
            this.smsCountDown();
          }
        } catch (err) {
          this.telLoginData.sessionId = null;
        }
      } else {
        this.telLoginData.sessionId = null;
      }
    },
    verifySuccess(verify) {
      this.verify = verify;
      if (verify.popupId == "code") {
        this.slideVerify(true);
      }
    },
    handlerLogin() {
      if (this.loginType === "password") {
        console.log("账号密码登录");
        this.accountLogin();
      } else {
        console.log("短信验证码登录");
        this.smsLogin();
      }
    },
    //  账号、密码登录
    accountLogin() {
      this.$refs["loginForm"].validate(async (valid) => {
        if (valid) {
          if (this.verify.captchaResult) {
            try {
              const {
                access_token: token,
                message,
                remaining_days,
                weak_password,
              } = await this.$api.submitLoginInfo({
                account: this.loginData.account,
                password: this.loginData.password,
                captchaVerifyParam: this.verify.captchaVerifyParam,
              });
              if (token) {
                this.loginData = {};
                await this.getUserDetail(token);
                this.$message.success("登录成功");
                this.go();
                if (weak_password) {
                  this.$alert(message, "提醒", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      console.log(action, message, remaining_days);
                    },
                  });
                }
              } else {
                this.$message.error("登录失败");
                this.initRespErrMsgBoxMark();
                this.$refs.CaptchaVerify.clear();
              }
            } catch (error) {
              this.loginData.sessionId = null;
              this.$refs.CaptchaVerify.clear();
              console.log("login error", error);
            }
          } else {
            this.$message.error("请先点击验证按钮开始验证");
          }
        } else {
          this.$message.error("登录失败，请检查必填项数据！");
        }
      });
    },
    smsLogin() {
      this.telLogin = true;
      this.$refs["loginFormTel"].validate(async (valid) => {
        if (valid) {
          if (this.verify.captchaResult) {
            try {
              const { access_token: token } = await this.$api.submitCodeLogin({
                mobile: this.telLoginData.telephone,
                code: this.telLoginData.registerCode,
                captchaVerifyParam: this.verify.captchaVerifyParam,
              });
              if (token) {
                await this.getUserDetail(token);
                this.$message.success("登录成功！");
                this.go();
              } else {
                this.$message.error("登录失败");
                this.loginData.sessionId = null;
                this.$refs.CaptchaVerify.clear();
                this.initRespErrMsgBoxMark();
              }
            } catch (error) {
              this.$refs.CaptchaVerify.clear();
              this.loginData.sessionId = null;
            }
          } else {
            this.$message.error("请先点击验证按钮开始验证");
          }
        } else {
          this.$message.error("登录失败，请检查必填项数据！");
        }
      });
      this.telLogin = false;
    },

    async getVerifiCode() {
			this.$refs.CaptchaVerify.clear()
			if (!this.telLoginData.telephone) {
				this.$message.error('请先输入手机号');
			} else {
				this.loginType = 'sms';
				this.$refs.CaptchaVerify.popup('code')
			}
		},
    //验证验证码
    async smsVerify() {
      let args = {
        mobile: this.telLoginData.telephone,
        code: this.telLoginData.registerCode,
      };
      if (this.telLoginData.sessionId) {
        try {
          let result = await this.$api.smsVerify(args);
          if (result) {
            await this.smsLogin();
          } else {
            this.telLoginData.sessionId = null;
          }
        } catch (err) {
          this.telLoginData.sessionId = null;
        }
      } else {
        this.$message.warning("请先完成验证");
      }
    },
    //  验证码页面的  登录按钮
    handlerSMSLogin() {
      this.$refs["loginFormTel"].validate((valid) => {
        if (valid) {
          console.log("ssss", this.telLoginData.sessionId);
          if (this.telLoginData.sessionId) {
            //  校对验证码是否正确
            this.smsVerify();
          } else {
            this.$message.warning("请先获取验证码");
          }
        } else {
          this.$message.error("登录失败，请检查必填项数据！");
        }
      });
    },
    //获取登录用户信息
    async getUserDetail(token) {
      this.$storage.set("jwt", token);
      this.$storage.set("jwtTime", Date.parse(new Date()));
      this.mxInitSwitch();
      let userinfo = await this.$api.getUserDetail();
      console.log("userinfo", userinfo);
      if (userinfo) {
        this.$storage.set("user_info", userinfo);
        this.handleUserInfo(userinfo);
      } else {
        this.$message.error("获取用户信息失败");
      }
    },
    //登录方式
    loginAccount() {
      this.isVisible = true;
      this.isHidden = false;
      this.loginType = "sms";
    },
    loginTel() {
      this.isVisible = false;
      this.isHidden = true;
      this.loginType = "password";
    },
    //路由跳转
    go(url = "/") {
      //跳转首页
      this.mxRedirect(url);
    },
    // 初始化响应错误弹窗标志
    initRespErrMsgBoxMark() {
      this.$store.commit("changeRespErrMsgBoxMark", false);
    },
  },
  mounted() {
    this.initRespErrMsgBoxMark();
  },
};
</script>

<style lang="stylus" scoped>
.auth-main {
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}

.loginTitle {
  height: 41px;
  line-height: 26px;
  color: rgba(24, 144, 255, 100);
  font-size: 18px;
  text-align: center;
  font-family: -apple-system;
  font-weight: bolder;
  margin-top: 10px;
  margin-bottom: 20px;
}

.input-item {
  margin-bottom: 25px !important;
}

// .input-item:last
// margin-bottom 50px !important
.login-input .el-input__inner {
  height: 50px;
}

.el-tabs__nav-wrap::after {
  height: 0px;
}

.el-tabs__nav {
  display: inline-block;
  float: none;
}

.el-tabs__header {
  text-align: center;
}

.el-input__prefix {
  left: 8px;
}

.el-tabs__header {
  margin-bottom: 24px;
}

.login-button {
  width: 100%;
  height: 50px;
  margin-top: 15px;
  border: none;
}

.login-button:hover {
  background: #48B4FF;
}

.get-register {
  width: 120px;
}

.el-form-item {
  margin-bottom: 5px;
}

.el-form-item__conten {
  height: 50px;
}

.login-way {
  font-size: 14px;
  color: #606266;
}

.login-wrapper {
  margin-top: -25px;
}

.remember {
  color: #757575;
}

.password {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
}

.login-wrapper {
  width: 300px;
}

.login-img-wrapper {
  padding-top: 30px;
  display: flex;
  justify-content: center;
}

.login-img {
  width: 48px;
  height: 48px;
}

.login-img-big {
  width: 100px;
  height: 39.52px;
}

>>>.nc_wrapper {
  margin: 0 auto;
}

>>>.el-dialog__body {
  padding-bottom: 50px;
}
</style>
